import docReady from '../../../assets/js/docReady';

const componentScope = document.querySelector('.job-application-form-component');

const succes = componentScope.querySelector('.job-application-form-succes');
if (succes) {
    succes.style.display = 'none';
}

const error = componentScope.querySelector('.error');
if (error) {
    error.style.display = 'none';
}

const inputFields = componentScope.querySelector('.job-application-form');

function submitForm(event) {
    const url = '/ajax/job-application/apply';
    event.preventDefault();

    const formData = new FormData();
    formData.append('name', document.getElementById('job-application-name').value);
    formData.append('email', document.getElementById('job-application-email').value);
    formData.append('linkedIn', document.getElementById('job-application-linkedin').value);
    formData.append('motivation', document.getElementById('job-application-motivation').value);
    formData.append('resume', document.getElementById('job-application-resume').files[0]);
    formData.append('job', document.title);

    const request = new XMLHttpRequest();
    request.open('POST', url, true);
    request.send(formData);

    function onsucces() {
        inputFields.style.display = 'none';
        succes.style.display = 'flex';
    }

    function onerror() {
        error.style.display = 'block';

        const element = document.getElementsByClassName('job-application-form')[0];
        element.classList.toggle('error');
    }

    request.onreadystatechange = () => {
        if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
            onsucces();
        } else {
            onerror(request.responseText);
        }
    };
}

docReady(() => {
    const forms = document.querySelectorAll('.job-application-form');

    if (forms) {
        forms.forEach((form) => {
            form.addEventListener('submit', submitForm);
        });
    }
});
